<!--
 * @Author: zhangruifeng
 * @Date: 2021-04-28 11:05:28
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-09-29 11:25:18
-->

<template>
  <div class="user_manage w00 h100">
    <div class="form-part w100 h100">
      <div class="all-organization h100 bcg_w">
        <div class="all-organization-title">
          <a-page-header style="font-size: 16px">企业机构</a-page-header>
          <a-tooltip>
            <template #title>编辑部门</template>
            <EditOutlined v-hasPermission="`ORG_EDITDEPT`" v-show="selectedDeptId" style="margin: auto; font-size: 20px; position: absolute; right: 65px" @click="onEditDepartment" />
          </a-tooltip>
          <a-tooltip>
            <template #title>新增部门</template>
            <PlusCircleOutlined v-hasPermission="`ORG_ADDDEPT`" style="margin: auto; font-size: 20px; position: absolute; right: 35px" @click="onAddDepartment" />
          </a-tooltip>
          <a-tooltip>
            <template #title>取消选中</template>
            <CloseOutlined v-show="selectedDeptId" style="margin: auto; font-size: 20px; position: absolute; right: 5px" @click="unSelectDepartment" />
          </a-tooltip>
        </div>
        <div class="all-organization-tree">
          <a-spin :spinning="treeLoading" wrapper-class-name="spin-treeloading-wrapper">
            <a-tree :show-icon="false" v-model:expandedKeys="expandedKeys" v-model:selectedKeys="selectedKeys" :block-node="true" :tree-data="departmentTreeData" :replace-fields="{ children: 'list', title: 'name', key: 'deptId' }" @select="onClickDepartment" style="position: absolute; padding-bottom: 2em">
              <template #title="item">
                <!-- <svg-icon icon-class="org" class-name="org_icon" v-if="item.parentId == 0" /> -->
                <PlusSquareFilled style="z-index: 1000" v-if="item?.list?.length && !expandedKeys.includes(item.deptId)" />
                <MinusSquareFilled style="z-index: 1000" v-else-if="item?.list?.length && expandedKeys.includes(item.deptId)" />
                <span> {{ item.name }} </span>
              </template>
            </a-tree>
          </a-spin>
        </div>
      </div>

      <!-- 表格页面 -->
      <div class="table-container bcg_w" v-show="showTable">
        <div class="table-container-title">
          <a-row>
            <a-col :span="4">
              <a-input v-model:value="searchName" placeholder="请输入姓名或花名搜索" @change="onUserSearchChange" allow-clear @press-enter="onSearchBtnClick" />
            </a-col>
            <a-col :span="4" style="margin-left: 1em">
              <a-space>
                <a-button type="primary" @click="onSearchBtnClick" :disabled="tableLoading">搜索</a-button>
                <a-button v-hasPermission="'ORG_ADD'" style="min-width: 120px" type="primary" :disabled="tableLoading" @click="addUser">创建新用户</a-button>
              </a-space>
            </a-col>
          </a-row>
        </div>
        <div class="table-container-section">
          <a-config-provider :locale="locale">
            <a-table size="small" class="staff_info_table" :data-source="userTableData" :columns="userTableColumns" bordered :row-key="record => record.userId" :loading="tableLoading" :scroll="{ x: 1400, y: 300 }" :pagination="tablePagination" @change="onTableChange">
              <template #sex="{ record }">{{ columnMap(sexOptions, record.sex) || '' }}</template>
              <template #jobs="{ record }">{{ columnMap(jobsOptions, record.jobs) || '' }}</template>
              <template #grades="{ record }">{{ columnMap(gradeOptions, record.grades) || '' }}</template>
              <template #workingState="{ record }">{{ columnMap(workingStateOptions, record.workingState) || '' }}</template>
              <template #roleIds="{ record }">
                <div v-for="role in record.roleIds" :key="role">{{ rolesOptions[role] }}</div>
              </template>
              <template #operation="{ record }">
                <a-space>
                  <span> <a v-hasPermission="'ORG_EDIT'" @click="editRow(record)">编辑</a> </span>
                  <a v-if="userInfo.userId == 1" @click="resetPassWord(record)"> 重置密码 </a>
                </a-space>
              </template>
            </a-table>
          </a-config-provider>
        </div>
      </div>
      <!-- 编辑界面 -->
      <div class="create-user bcg_w" v-show="!showTable">
        <a-spin :spinning="saveUserSpinShow" class="loading" size="large" tip="正在保存...">
          <a-row style="justify-content: center">
            <a-page-header :title="!isUpdateUser ? '创建用户账号' : '修改用户账号信息'" />
          </a-row>
          <div class="create-user-form">
            <a-form layout="horizontal" ref="createUserForm" :model="createUserFormData" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-row>
                <a-col :span="12">
                  <a-form-item label="花名" name="userCode">
                    <a-input v-model:value="createUserFormData.userCode" placeholder="请输入花名" @change="inputUserCode" />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="姓名" name="name">
                    <a-input v-model:value="createUserFormData.name" placeholder="请输入姓名" @change="inputUserName" />
                  </a-form-item>
                </a-col>

                <a-col :span="12">
                  <a-form-item label="密码" name="password" v-if="!isUpdateUser">
                    <a-input-password autocomplete="off" v-model:value.trim="createUserFormData.password" placeholder="长度须大于6位，包含数字、字母，支持特殊字符" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="邮箱" name="email">
                    <a-input v-model:value="createUserFormData.email" placeholder="请输入邮箱" @change="inputUserEmail" />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="手机" name="mobile">
                    <a-input v-model:value="createUserFormData.mobile" placeholder="请输入手机号码" @change="inputUserMobile" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="性别" name="sex">
                    <a-radio-group button-style="solid" v-model:value="createUserFormData.sex" style="line-height: unset">
                      <a-radio-button :value="item.value" v-for="(item, index) in sexOptions" :key="index">{{ item.text }}</a-radio-button>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="出生日期" name="birthDate">
                    <a-date-picker v-model:value="createUserFormData.birthDate" placeholder="请选择出生日期" style="width: 100%" :allow-clear="false" :format="['YYYY-MM-DD']" :disabled-date="disabledDate"></a-date-picker>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-item label="职级" name="rank" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                    <a-radio-group button-style="solid" v-model:value="createUserFormData.grades" style="line-height: unset">
                      <a-radio-button :value="item.value" v-for="(item, index) in gradeOptions" :key="index">{{ item.text }}</a-radio-button>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="岗位" name="jobs" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                    <a-radio-group button-style="solid" v-model:value="createUserFormData.jobs" style="line-height: unset">
                      <a-radio-button style="margin-bottom: 10px" :value="item.value" v-for="(item, index) in jobsOptions" :key="index">{{ item.text }}</a-radio-button>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="基本工资" name="basicSalary">
                    <a-input-number style="width: 100%" :min="1" v-model:value="createUserFormData.basicSalary" placeholder="请输入基本工资" />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="入职日期" name="hireDate">
                    <a-date-picker v-model:value="createUserFormData.hireDate" placeholder="请选择入职日期" style="width: 100%" :allow-clear="false" :format="['YYYY-MM-DD']" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="在职状态" name="workingState">
                    <a-radio-group button-style="solid" v-model:value="createUserFormData.workingState" style="line-height: unset" @change="onWorkingStateChange">
                      <a-radio-button :value="item.value" v-for="(item, index) in workingStateOptions" :key="index">{{ item.text }}</a-radio-button>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="所属部门" name="deptId">
                    <a-tree-select @change="getRoleListByDeptId" v-model:value="createUserFormData.deptId" :tree-data="departmentTreeData" placeholder="请选择所属部门" v-bind="treeSelectProps" />
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row>
                <a-col :span="12" v-if="createUserFormData.workingState == 'DIMISSION'">
                  <a-form-item label="离职日期" name="departureDate">
                    <a-date-picker v-model:value="createUserFormData.departureDate" placeholder="请选择离职日期" style="width: 100%" :allow-clear="false" :format="['YYYY-MM-DD']"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="权限角色" name="roleIds">
                    <a-select v-model:value="createUserFormData.roleIds" mode="multiple">
                      <a-select-option v-for="role in roleList" :key="role" :value="role.roleId">
                        {{ role.roleName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-divider></a-divider>
              <a-form-item style="margin-top: 10px">
                <a-row>
                  <a-col :span="4" :offset="14">
                    <a-button :loading="saveUserSpinShow" type="primary" @click="onSaveUserConfirm">确定</a-button>
                  </a-col>
                  <a-col :span="4" :offset="2">
                    <a-button @click="onSaveUserCancel">取消</a-button>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-form>
          </div>
        </a-spin>
      </div>
    </div>
    <!-- 新增编辑部门弹窗 -->
    <a-modal v-model:visible="addDepModalVisible" :title="operateDepaType" ok-text="确认" cancel-text="取消" @ok="onAddDeptConfirm" @cancel="onAddDeptCancel" :mask-closable="false">
      <a-form class="department_info" ref="addDeptForm" :model="addDepartmentFormData" :rules="addDeptFormRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-form-item label="部门名称" name="name" required>
          <a-input v-model:value="addDepartmentFormData.name" placeholder="请输入部门名称" @change="addDepartName" />
        </a-form-item>
        <a-form-item label="部门类型" name="deptType" required>
          <a-select v-model:value="addDepartmentFormData.deptType" placeholder="请选择部门类型" style="width: 100%" :options="deptTypeOptions" />
        </a-form-item>
        <a-form-item label="上级部门" name="parentId" required>
          <a-tree-select v-model:value="addDepartmentFormData.parentId" :tree-data="departmentTreeData" placeholder="请选择上级部门" v-bind="treeSelectProps" />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 重置密码提示弹窗 -->
    <delect-modal :delect-modal-visible="delectModalVisible" :delect-modal-title="'重置密码提示'" :delect-modal-content="'即将重置该用户密码，是否确认重置？'" @onOkClick="onDelectModalOk" @onCancelClick="onDelectModalCancel" />
  </div>
</template>

<script>
import moment from 'moment';
import { getDepartmentTreeData, saveDepartment, saveUserInfo, getDeptUserListData, getDeptUserListDataCancel, getUserListData, getRoleList, resetPassWord } from '@/api/org/account.js';
import { PlusCircleOutlined, EditOutlined, CloseOutlined, PlusSquareFilled, MinusSquareFilled } from '@ant-design/icons-vue';
import { getRoleListData } from '@/api/systemManage/roleManage.js';
import locale from 'ant-design-vue/lib/locale-provider/zh_CN';
import DelectModal from '@/components/DelectModal/index.vue';
import { mapState } from 'vuex';

export default {
  components: {
    PlusCircleOutlined,
    EditOutlined,
    CloseOutlined,
    PlusSquareFilled,
    MinusSquareFilled,
    DelectModal,
  },
  data() {
    return {
      // 部门下拉选择树配置项
      treeSelectProps: {
        replaceFields: { children: 'list', title: 'name', key: 'deptId', value: 'deptId' },
        style: { width: '100%' },
        dropdownStyle: { maxHeight: '200px', overflow: 'auto' },
        treeNodeFilterProp: 'title',
        treeDefaultExpandAll: true,
      },
      resetRecord: null,
      // 重置密码提示框
      delectModalVisible: false,
      roleList: [],
      rolesOptions: {},
      locale,
      searchName: '', //搜索花名或者姓名
      expandedKeys: [],
      selectedKeys: [],
      treeLoading: false,
      tableLoading: false,
      operateDepaType: '',
      // 表格分页配置
      tablePagination: {
        limit: '30',
        page: '1',
        pageSize: 30,
        showTotal: total => `总计${total}条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50'],
      },
      deptTypeOptions: [
        { label: '运营组', value: 'OPERATION' },
        { label: '视频组', value: 'VIDEO' },
        { label: '其它', value: 'OTHER' },
      ],
      // 岗位选项
      jobsOptions: [
        { text: 'ADMIN', value: 'ADMIN' },
        { text: '运营', value: 'OPERATION' },
        { text: '编导', value: 'SCENARIST' },
        { text: '制片', value: 'FILEMAKER' },
        { text: '拍摄', value: 'PHOTOGRAPHER' },
        { text: '后期', value: 'POSTER' },
        { text: '媒介', value: 'MEDIUM' },
        { text: '销售', value: 'SELL' },
        { text: '人力', value: 'MANPOWER' },
        { text: '风控', value: 'RISKMANAGER' },
        { text: '财务', value: 'TREASURER' },
        { text: '技术', value: 'EXPLOIT' },
        { text: '其它', value: 'OTHER' },
      ],
      //职级选项
      gradeOptions: [
        { text: '经理', value: 'MANAGER' },
        { text: '组长', value: 'GROUPLEADER' },
        { text: '组员', value: 'GROUPMEMBER' },
      ],
      sexOptions: [
        { text: '男', value: 'MALE' },
        { text: '女', value: 'FEMALE' },
      ],
      workingStateOptions: [
        { text: '在职', value: 'WORKING' },
        { text: '离职', value: 'DIMISSION' },
      ],
      // 显示新增部门的输入框
      addDepModalVisible: false,
      saveUserSpinShow: false,
      // 部门列表数据
      departmentData: [],
      // 部门树形数据
      departmentTreeData: [],
      createUserFormData: {
        sex: 'MALE', //性别
        workingState: 'WORKING', //在职状态
      },
      addDeptFormRules: {
        name: [{ required: true, message: '必填项', trigger: 'blur' }],
        deptType: [{ required: true, message: '必选项', trigger: 'blur' }],
        parentId: [{  required: true, message: '必选项', trigger: 'blur' }],
      },
      selectedDeptId: '',
      addDepartmentFormData: {
        name: '',
      },
      showTable: true,
      // 用户列表数据列配置
      userTableColumns: [
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
          ellipsis: true,
          width: 100,
        },
        {
          title: '花名',
          dataIndex: 'userCode',
          key: 'userCode',
          ellipsis: true,
          width: 100,
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          key: 'email',
          ellipsis: true,
          width: 200,
          ellipsis: true,
        },
        {
          title: '性别',
          dataIndex: 'sex',
          key: 'sex',
          slots: { customRender: 'sex' },
          width: 50,
        },
        {
          title: '手机',
          dataIndex: 'mobile',
          key: 'mobile',
          width: 120,
        },
        {
          title: '岗位',
          dataIndex: 'jobs',
          key: 'jobs',
          slots: { customRender: 'jobs' },
          width: 80,
        },
        {
          title: '职级',
          dataIndex: 'grades',
          key: 'grades',
          slots: { customRender: 'grades' },
          width: 80,
        },
        {
          title: '入职日期',
          dataIndex: 'hireDate',
          key: 'hireDate',
          width: 100,
        },
        {
          title: '出生日期',
          dataIndex: 'birthDate',
          key: 'birthDate',
          width: 100,
        },
        {
          title: '所属部门',
          dataIndex: 'deptName',
          key: 'deptName',
          width: 100,
        },
        {
          title: '角色权限',
          dataIndex: 'roleIds',
          slots: { customRender: 'roleIds' },
          width: 120,
        },
        {
          title: '在职状态',
          dataIndex: 'workingState',
          key: 'workingState',
          slots: { customRender: 'workingState' },
          width: 80,
        },
        {
          title: '离职日期',
          dataIndex: 'departureDate',
          key: 'departureDate',
          width: 100,
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          slots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      // 用户列表数据
      userTableData: [],
      rules: {
        password: [
          { min: 6, message: '密码不少于6位', trigger: 'blur' },
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        userCode: [{ required: true, message: '请输入花名', trigger: 'blur' }],
        email: [
          {
            required: true,
            validator: function emailRule(rule, value) {
              if (!value) {
                return Promise.reject('请输入邮箱');
              } else {
                if (value != '') {
                  let reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                  if (!reg.test(value)) {
                    return Promise.reject('请输入有效的邮箱');
                  } else {
                    return Promise.resolve();
                  }
                }
              }
            },
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            validator: function mobileRule(rule, value) {
              if (!value) {
                return Promise.reject('请输入手机号码');
              } else {
                if (value !== '') {
                  var reg = /^1[3456789]\d{9}$/;
                  if (!reg.test(value)) {
                    return Promise.reject('请输入有效的手机号码');
                  } else {
                    return Promise.resolve();
                  }
                }
              }
            },
            trigger: 'blur',
          },
        ],
        basicSalary: [
          {
            required: true,
            trigger: 'blur',
            validator: function emailRule(rule, value) {
              if (!value) {
                return Promise.reject('请输入基本工资');
              } else {
                return Promise.resolve();
              }
            },
          },
        ],
        hireDate: [{ type: 'object', required: true, message: '请选择入职日期', trigger: 'blur' }],
        birthDate: [{ type: 'object', required: true, message: '请选择出生日期', trigger: 'blur' }],
        deptId: [{  required: true, number: true, message: '请选择所属部门', trigger: 'blur' }],
        departureDate: [{ type: 'object', required: true, message: '请选择离职日期', trigger: 'blur' }],
        roleIds: [{ required: true, type: 'array', message: '请选择所属权限角色', trigger: 'blur' }],
      },
      currentNode: {},
    };
  },
  created() {
    this.getDepartmentTree();
    this.getDeptUserList();
    this.getRoleList();
  },
  computed: {
    ...mapState({
      userInfo: state => state.oauth.userInfo,
    }),
    isUpdateUser() {
      return !!this.createUserFormData.userId;
    },
    isUpdateDepartment() {
      return !!this.currentNode.deptId;
    },
  },
  methods: {
    /** 打开重置密码提示框
     * @param {*} record
     * @return {*}
     */
    resetPassWord(record) {
      this.resetRecord = record;
      this.delectModalVisible = true;
    },
    /** 重置用户密码
     * @param {*}
     * @return {*}
     */
    onDelectModalOk() {
      this.delectModalVisible = false;
      resetPassWord([this.resetRecord?.userCode]).then(res => {
        if (res.code == 0) {
          this.$message.success('重置用户密码成功！');
        }
      });
    },
    /**删除弹窗取消
     * @param {*}
     * @return {*}
     */ onDelectModalCancel() {
      this.delectModalVisible = false;
    },
    // 根据部门ID获取角色
    async getRoleListByDeptId(deptId) {
      this.createUserFormData.roleIds = []; // 改变部门的时候就把上次选择的权限角色清空
      if (!deptId) return;
      const res = await getRoleList({ deptId: deptId });
      this.roleList = res.code === 0 ? res.role : [];
    },
    //获取所有角色数据
    async getRoleList() {
      let roleName = '';
      this.rolesOptions = {};
      let res = await getRoleListData(roleName, 1000, 1);
      if (res.page && res.page.list && res.page.list.length > 0) {
        res.page.list.forEach(item => {
          this.rolesOptions[item.roleId] = item.roleName;
        });
      }
    },
    addDepartName() {
      this.addDepartmentFormData.name = this.addDepartmentFormData.name.trim();
    },
    inputUserCode() {
      this.createUserFormData.userCode = this.createUserFormData.userCode.trim();
    },
    inputUserName() {
      this.createUserFormData.name = this.createUserFormData.name.trim();
    },
    inputUserEmail() {
      this.createUserFormData.email = this.createUserFormData.email.trim();
    },
    inputUserMobile() {
      this.createUserFormData.mobile = this.createUserFormData.mobile.trim();
    },
    passwordChange(value) {
      this.createUserFormData.password = this.createUserFormData.password.trim();
    },
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    // 部门数据过滤
    filterDepartment(input, option) {
      return option.props.value.indexOf(input) >= 0;
    },
    // 列字典数据映射
    columnMap(columnOptions, key) {
      if (key) {
        return columnOptions.filter(item => {
          return item.value == key;
        })[0]?.text;
      }
    },
    // 获取部门树形数据
    getDepartmentTree() {
      this.treeLoading = true;
      getDepartmentTreeData().then(res => {
        if (res.code === 0) {
          this.departmentTreeData = [res.sysDeptEntity];
          this.autoOpendeptId = res.sysDeptEntity.deptId;
          this.$nextTick(() => {
            let deptId = this.autoOpendeptId;
            this.expandedKeys = [deptId];
          });
        }
        this.treeLoading = false;
      });
    },
    /**获取部门下的用户 */
    getDeptUserList() {
      if (this.tableLoading === true) {
        getDeptUserListDataCancel('cancel request');
      }
      this.tableLoading = true;
      let postData = {
        ...this.tablePagination,
        deptId: '' + this.selectedDeptId,
        name: this.searchName ? this.searchName : null,
        userCode: this.searchUserCode ? this.searchUserCode.trim() : null,
      };
      getDeptUserListData(postData)
        .then(res => {
          this.userTableData = res.page.list;
          this.tablePagination.current = res.page.currPage;
          this.tablePagination.pageSize = res.page.pageSize;
          this.tablePagination.total = res.page.totalCount;
          this.tableLoading = false;
        })
        .catch(() => {});
    },
    /**部门树点击事件 */
    onClickDepartment(keys, e) {
      this.showTable = true;
      this.$refs.createUserForm.resetFields();
      this.createUserFormData = {};
      this.createUserFormData.deptId = keys[0];
      this.createUserFormData.deptName = e.node.title;
      this.tablePagination.page = '1';
      this.addDepartmentFormData = {
        deptId: e.node.dataRef.deptId,
        name: e.node.dataRef.name,
        parentId: e.node.dataRef.parentId,
        deptType: e.node.dataRef.deptType,
      };
      // 如果再次点击当前节点，则取消当前节点的选中
      if (e.node.dataRef.deptId == this.currentNode.deptId) {
        this.currentNode = {};
        this.selectedDeptId = '';
      } else {
        this.currentNode = { ...this.addDepartmentFormData };
        this.selectedDeptId = this.addDepartmentFormData.deptId;
      }
      this.getDeptUserList();
    },
    // 新增部门
    onAddDepartment() {
      this.operateDepaType = '新增部门';
      this.addDepartmentFormData = {};
      this.addDepModalVisible = true;
    },
    // 编辑部门
    onEditDepartment() {
      this.operateDepaType = '编辑部门';
      this.addDepModalVisible = true;
    },
    // 取消部门选中
    unSelectDepartment() {
      this.showTable = true;
      this.createUserFormData = {
        sex: 'MALE', //性别
        workingState: 'WORKING', //在职状态
      };
      this.addDepartmentFormData = { name: '' };
      this.selectedDeptId = '';
      this.selectedKeys = [];
      this.getDeptUserList();
    },
    // 新增部门确定按钮事件
    onAddDeptConfirm() {
      this.$refs.addDeptForm.validate().then(res => {
        let postData = {
          ...this.addDepartmentFormData,
        };
        saveDepartment(postData).then(res => {
          if (res.code === 0) {
            this.addDepModalVisible = false;
            this.getDepartmentTree();
          }
        });
      });
    },
    // 取消添加部门
    onAddDeptCancel() {
      this.$refs.addDeptForm.clearValidate();
      this.addDepModalVisible = false;
      this.addDepartmentFormData = this.currentNode;
    },
    //新增用户
    addUser() {
      this.roleList = []; //清空角色列表
      this.createUserFormData.userId = null;
      this.createUserFormData.grades = 'GROUPMEMBER';
      this.createUserFormData.deptId = this.selectedDeptId;
      this.getRoleListByDeptId(this.createUserFormData.deptId);
      this.createUserFormData.userCode = '';
      this.createUserFormData.password = '';
      this.showTable = !this.showTable;
    },
    onSaveUserConfirm() {
      this.$refs.createUserForm.validateFields().then(() => {
        this.saveUserSpinShow = true;
        let postData = {
          ...this.createUserFormData,
          birthDate: this.createUserFormData.birthDate.format('YYYY-MM-DD'),
          hireDate: this.createUserFormData.hireDate.format('YYYY-MM-DD'),
          departureDate: this.createUserFormData.departureDate ? this.createUserFormData.departureDate.format('YYYY-MM-DD') : null,
        };
        saveUserInfo(postData).then(async response => {
          if (response.code === 0) {
            if (postData.userId) {
              this.$message.success('用户修改成功！');
            } else {
              this.$message.success('用户新增成功!');
            }
            await this.getDeptUserList();
            this.createUserFormData = {};
            this.showTable = !this.showTable;
          }
          this.saveUserSpinShow = false;
          this.createUserFormData.deptId = postData.deptId;
          this.createUserFormData.deptName = postData.deptName;
        });
      });
    },
    onSaveUserCancel() {
      this.showTable = !this.showTable;
      this.$refs.createUserForm.resetFields();
      this.createUserFormData = {
        sex: 'MALE', //性别
        workingState: 'WORKING', //在职状态
      };
    },

    // 表格
    onTableChange(pagination, filters, sorter) {
      this.tablePagination.page = '' + pagination.current;
      this.tablePagination.limit = pagination.pageSize.toString();
      this.tablePagination.pageSize = pagination.pageSize;
      this.getDeptUserList();
    },
    // 用户列表编辑
    editRow(item) {
      this.getRoleListByDeptId(item.deptId);
      item.departureDate = item.departureDate ? moment(item.departureDate) : '';
      this.showTable = !this.showTable;
      this.createUserFormData = {
        ...item,
        birthDate: moment(item.birthDate),
        hireDate: moment(item.hireDate),
      };
    },

    onWorkingStateChange(e) {
      if (e.target.value === 'DIMISSION') {
        this.createUserFormData.departureDate = moment();
      } else {
        this.createUserFormData.departureDate = null;
      }
    },
    onUserSearchChange(val) {
      this.searchUserCode = this.searchName = val.target.value;
      if (this.searchName == '') {
        this.getDeptUserList();
      }
      this.searchName = this.searchName.trim();
    },
    onSearchBtnClick() {
      this.tablePagination.page = '1';
      this.getDeptUserList();
    },
  },
};
</script>

<style lang="less">
@import 'index.less';
</style>
<style lang="less" scoped>
.user_manage {
  .all-organization {
    @color: #2f70f4;
    width: 204px;
    margin-right: 12px;
    border-radius: 8px;
    :deep(.ant-tree-node-content-wrapper) {
      line-height: 30px;
      height: 30px;
      &.ant-tree-node-selected {
        color: @color;
        .anticon {
          color: @color !important;
        }
      }
      .anticon {
        margin-right: 12px;
        color: rgba(112, 112, 112, 1);
      }
    }
    :deep(.ant-tree-switcher) {
      opacity: 0;
      transform: translateX(25px);
    }
  }
  .table-container {
    :deep(.ant-input-affix-wrapper) {
      height: 32px;
      transform: translateY(-2px);
    }
  }
}
:deep(.staff_info_table) {
  .ant-table-body,
  .ant-table-body-inner {
    max-height: calc(100vh - 230px) !important;
  }
  .ant-table-pagination {
    margin-bottom: 0 !important;
  }
}
.form :deep(.ant-form-item-label) {
  line-height: 40px;
}
.department_info {
  .ant-input {
    height: 32px;
  }
}
</style>